export enum OrdersQueryParamKey {
  PLAN_ROUTE = 'planRoute',
}
